import { render, staticRenderFns } from "./anquanFooter.vue?vue&type=template&id=166f0883&scoped=true&"
var script = {}
import style0 from "./anquanFooter.vue?vue&type=style&index=0&id=166f0883&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f0883",
  null
  
)

export default component.exports